import { useState } from "react";
import type { FormEvent } from "react";

interface CreateTeamModalProps {
  onClose: () => void;
  onSubmit: (data: { name: string; slug: string }) => void;
  isLoading?: boolean;
  error?: string | null;
}

export function CreateTeamModal({ onClose, onSubmit, isLoading, error }: CreateTeamModalProps): JSX.Element {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit({ name: name.trim(), slug: slug.trim() || name.trim().toLowerCase().replace(/\s+/g, "-") });
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        className="modal-content surface"
        style={{
          background: "var(--color-surface)",
          padding: "2rem",
          borderRadius: "12px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginBottom: "0.5rem" }}>Create New Team</h2>
        <p style={{ color: "var(--color-text-muted)", marginBottom: "1.5rem" }}>
          Create a team to start building forms
        </p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div
              style={{
                padding: "0.75rem",
                marginBottom: "1.5rem",
                background: "var(--color-error-bg, #fee)",
                border: "1px solid var(--color-error, #f44)",
                borderRadius: "8px",
                color: "var(--color-error, #c00)",
              }}
            >
              {error}
            </div>
          )}

          <div style={{ marginBottom: "1.5rem" }}>
            <label
              htmlFor="team-name"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: 500,
              }}
            >
              Team Name *
            </label>
            <input
              id="team-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter team name"
              required
              autoFocus
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--color-border)",
                borderRadius: "8px",
                fontSize: "1rem",
                background: "var(--color-background)",
              }}
            />
          </div>

          <div style={{ marginBottom: "2rem" }}>
            <label
              htmlFor="team-slug"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: 500,
              }}
            >
              Team Slug (optional)
            </label>
            <input
              id="team-slug"
              type="text"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              placeholder="team-slug"
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--color-border)",
                borderRadius: "8px",
                fontSize: "1rem",
                background: "var(--color-background)",
              }}
            />
            <p style={{ color: "var(--color-text-muted)", fontSize: "0.875rem", marginTop: "0.5rem" }}>
              Used for URLs. Auto-generated from name if not provided.
            </p>
          </div>

          <div style={{ display: "flex", gap: "0.75rem", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="button ghost"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="button primary"
              disabled={!name.trim() || isLoading}
            >
              {isLoading ? "Creating..." : "Create Team"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
